<template>
  <header class="main-header fz-main-header"
          :class="[
      'main-header',
      'fz-main-header',
      !isHiddenMenu ? 'fixed-header' : ''
    ]">
    <!-- Header Navbar -->
    <nav class="navbar navbar-static-top"
         role="navigation">
      <div class="top-menu">
        <router-link to="/statistics"
                     class="top-menu-item">
          <span>首&nbsp;页</span>
        </router-link>
        <router-link to="/products"
                     class="top-menu-item">
          <span>产&nbsp;品</span>
        </router-link>
        <router-link to="/service"
                     class="top-menu-item ">
          <span>服&nbsp;务</span>
        </router-link>
      </div>

      <!-- Sidebar toggle button-->
      <!-- <a href="javascript:void(0);" class="sidebar-toggle" data-toggle="push-menu" role="button">
                <span class="sr-only">切换侧边栏显示状态</span>
            </a> -->
      <!-- Navbar Right Menu -->
      <div class="navbar-custom-menu"
           v-if="username">
        <ul class="nav navbar-nav">
          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->
            <a href="/board_new"
               v-if="isStatisticsPage"
               title="全屏">
              <i class="fa fa-arrows-alt"></i>
            </a>
          </li>
          <!-- Notifications Menu -->
          <li class="dropdown notifications-menu">
            <!-- Menu toggle button -->

            <a class="dropdown-toggle"
               href="javascript:;"
               @click="toToMessage()">
              <i class="fa fa-bell-o"></i>
              <span class="label label-danger">{{ $parent.messages }}</span>
            </a>
          </li>

          <!-- User Account Menu -->
          <li class="dropdown user user-menu">
            <!-- Menu Toggle Button -->
            <a href="#"
               class="dropdown-toggle"
               data-toggle="dropdown">
              <!-- The user image in the navbar-->
              <img src="../../static/img/user2-160x160.png"
                   class="user-image"
                   alt="User Image" />
              <!-- hidden-xs hides the username on small devices so only the image appears. -->
              <span class="hidden-xs">{{ username }}</span>
            </a>
          </li>

          <!--logout-->
          <li class="fz-out">
            <a href="#"
               @click="logOut()">退&nbsp;出</a>
          </li>
        </ul>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "top",
  computed: {
    ...mapState(["isHiddenMenu", "isHiddenTop", "isStatisticsPage"])
  },
  data () {
    return {
      user: {},

      username: ""
    };
  },
  mounted () {
    let user = window.window.sessionStorage.user;
    user = user && JSON.parse(user);
    console.log(this.$route);
    console.log(user);
    this.user = user;
    this.username = user.name;
  },
  methods: {
    ...mapActions({
      setUserInfo: "setUserInfo",
      LOGINOUT: "logOut"
    }),
    logOut () {
      localStorage.removeItem("token");
      this.LOGINOUT();
      window.location.href = "/login";
    },
    toToMessage () {
      this.$router.push({ path: "/business/message" });
    }
  }
};
</script>

<style lang="scss" scoped>
.top-menu {
  display: inline-block;
  margin-left: 40px;
}
.top-menu-item {
  display: inline-block;
  min-height: 50px;
  line-height: 50px;
  padding-left: 35px;
  padding-right: 35px;
  color: #fff;
}
.main-header .navbar {
  margin-left: 0 !important;
}
.skin-black .main-header .navbar {
  background-color: #111619;
}
.fixed-header {
  position: fixed !important;
  width: 100% !important;
  top: 0;
  left: 0;
}
.fz-out {
  font-size: 16px;
}
</style>
